<ng-container *ngIf="customerAccount">
    <header class="header--well">
        <ul>
            <li class="header__title">
                <h2>Account &ndash; {{customerAccount.accountName}} ({{customerAccount.customerAccountNumberId}})</h2>
            </li>
            <li>
                <div class="pull-right"><b>Account Balance:</b> {{customerAccount.accountBalance.toFixed(2) | dollar}}</div>
            </li>
        </ul>
    </header>

    <div class="well">
        <h2>Account Details <button class="icon--edit btn--default" [disabled]="customerAccount.isRedactEnabled" type="button" (click)="editIconClicked()" *ngIf="customerManagedAccount"> Edit Account</button></h2>
        <fieldset>
            <div class="row">
                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Account Type</label>
                    <div class="mvd_form-control">{{customerAccount.accountType}}</div>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Account Status</label>
                    <div class="mvd_form-control">
                        {{customerAccount.accountStatus}}
                    </div>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Account Name</label>
                    <div class="mvd_form-control">{{customerAccount.accountName}}</div>
                </div>

                <div class="col-sm-6 col-md-3 mvd_form-group">
                    <label>Description</label>
                    <div class="mvd_form-control">{{customerAccount.accountDescription}}</div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>Type</label>
                    <div class="mvd_form-control">Mailing</div>
                </div>
                <div class="col-sm-4 col-md-3 mvd_form-group">
                    <label>Address</label>
                    <input class="mvd_form-control" type="text" disabled [ngModel]="customerAccount.accountAddress?.addressLine1" />
                </div>
                <div class="col-sm-4 col-md-3 mvd_form-group" *ngIf="customerAccount.accountAddress?.addressLine2">
                    <label>Ste, Apt, Etc</label>
                    <div class="mvd_form-control">{{customerAccount.accountAddress?.addressLine2}}</div>
                </div>
            </div>

            <div class="row">
				<div class="col-sm-3 col-md-2 mvd_form-group">
					<label>ZIP Code</label>
					<p-inputMask styleClass="mvd_form-control" [ngModel]="customerAccount.accountAddress?.postalZipCode" mask="99999?-9999" disabled></p-inputMask>
				</div>
                <div class="col-sm-3 mvd_form-group">
                    <label>City</label>
                    <div class="mvd_form-control">{{customerAccount.accountAddress?.city}}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>State</label>
                    <div class="mvd_form-control">{{getValues(customerAccount.accountAddress?.jurisdictionId, states)}}</div>
                </div>
                <div class="col-sm-3 mvd_form-group">
                    <label>County</label>
                    <div class="mvd_form-control">{{getValues(customerAccount.accountAddress?.countyId, counties)}}</div>
                </div>
                <!--<div class="col-sm-3 mvd_form-group">Country</div>-->
            </div>
            <div class="row">
                <div class="col-sm-3 mvd_form-group">
                    <label>Preferred Contact Method</label>
					<div class="mvd_form-control">{{preferredContactMethod}}</div>
                </div>
            </div>
        </fieldset>

        <h2>Contact Methods</h2>
        <table class="mvd_table--primeng">
            <thead>
                <tr>
                    <th>Contact Type</th>
                    <th>Contact Info</th>
                    <th>Text/Email Enabled</th>
                </tr>
            </thead>
            <tbody>

                <tr *ngFor="let contact of customerAccount.accountContacts">
                    <td>{{getValues(contact.contactMethodTypeID, contactMethods)}}</td>
                    <td>{{contact.customerContactValue}}</td>
                    <td><input type="checkbox" disabled="disabled" [checked]="contact.isCorrespondenceEnabled"></td>
                </tr>

            </tbody>
        </table>

        <h2>Services</h2>
        <div class="mvd_form-group">
            <ul class="list--bulleted--content">
                <li><a href="javascript:void(0);" (click)="serviceHistoryLinkClicked()">Financial Receipt History</a></li>
                <li>Receipts</li>
            </ul>
        </div>

        <h2>Finance</h2>
        <div class="mvd_form-group">
            <ul class="list--bulleted--content">
                <li>Vouchers</li>
                <li ifSecurityTransaction="DisbursementRequest"><a href="javascript:void(0);" (click)="requestDisbursementLinkClicked()" *ngIf="customerManagedAccount">Disbursement Request</a></li>
            </ul>
        </div>
    </div>
</ng-container>